<!-- Navigation -->
<fuse-vertical-navigation class="dark print:hidden"
    [ngClass]="usrDtls && usrDtls['clnt_id'] == 8 ? 'wms-sidebar' : 'bg-gray-900'" [appearance]="navigationAppearance"
    [hoverExpand]="!(usrDtls && usrDtls['clnt_id'] == 8)"
    [mode]="isScreenSmall ? 'over' : 'side'" [name]="'mainNavigation'" [navigation]="navigation.default"
    [opened]="!isScreenSmall" *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">
    <ng-container fuseVerticalNavigationContentHeader>

        <!-- Client 8: clean logo block -->
        <div class="wms-sidebar-brand"
            *ngIf="usrDtls && usrDtls['clnt_id'] == 8 && clntTntDtls && clntTntDtls.length && PrfieImage && (fullimg || lgimg)">
            <img [src]="PrfieImage" alt="Logo">
        </div>

        <!-- All other clients: unchanged -->
        <div class="flex items-center justify-center"
            *ngIf="!(usrDtls && usrDtls['clnt_id'] == 8) && clntTntDtls && clntTntDtls.length"
            style="height: 0px; background : #fff;    border-right: 2px solid #e7e7e7;margin: 50px;">
            <img style="width: 100%; margin-top: 0px; height: 64px;" [src]="PrfieImage" *ngIf="fullimg">
            <img style="width: 100%; margin-top: 0px; height: 64px;" [src]="PrfieImage" *ngIf="lgimg">
            <!-- <img style="width: 100%; margin-top: 0px; height:75px " [src]="clntTntDtls[0].dsply_lgo_url_tx" *ngIf="fullimg">
            <img style="width:64px;height:64px ; margin: 0px auto;" [src]="clntTntDtls[0].dsply_lgo_url_tx"
                *ngIf="lgimg"> -->
        </div>
    </ng-container>
    <!-- Client 8: decorative skyline after the last menu item (scrolls with the menu) -->
    <ng-container fuseVerticalNavigationContentFooter>
        <div class="wms-sidebar-skyline" *ngIf="usrDtls && usrDtls['clnt_id'] == 8"></div>
    </ng-container>
</fuse-vertical-navigation>


<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div style="height:75px"
        class="bc-img relative flex flex-0 items-center w-full px-4 md:px-6 z-1 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden mblevw_hdr_bgrnd"
        [ngClass]="usrDtls && usrDtls.rle_nm ==  'BCCFC Benificary ' ? 'pstnAbs' : ' '" [class.rmc-hdr]="isRmcHdr">
        <!-- Client 8: decorative bridge banner on the right side of the header -->
        <div class="rmc-hdr-banner" *ngIf="isRmcHdr" aria-hidden="true"></div>

        <div class="flex items-center pr-2 space-x-2" *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">
            <!-- Navigation toggle button -->
            <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button (compact / full sidebar) - all clients -->
            <button class="hidden md:inline-flex" mat-icon-button (click)="toggleNavigationAppearance()">
                <mat-icon [svgIcon]="'heroicons_outline:switch-horizontal'"></mat-icon>
            </button>
            <!-- Client 8: home button -->
            <button type="button" class="rmc-home-btn" *ngIf="isRmcHdr" (click)="goHome()" matTooltip="Home">
                <mat-icon>home</mat-icon>
            </button>
        </div>

        <!-- Client 8: title + breadcrumb, left aligned -->
        <div class="rmc-hdr-main" *ngIf="isRmcHdr">
            <div class="rmc-hdr-sep"></div>
            <div class="rmc-hdr-txt">
                <div class="rmc-hdr-nm">{{clntTntDtls && clntTntDtls.length ? clntTntDtls[0].clnt_nm : ''}}</div>
                <div class="rmc-hdr-crumb">
                    <ng-container *ngFor="let c of rmcCrumbs; let first = first">
                        <mat-icon *ngIf="!first" class="rmc-crumb-sep">chevron_right</mat-icon>
                        <span>{{c}}</span>
                    </ng-container>
                    <span *ngIf="usrDtls.hyrchy_hndlr_tx" class="rmc-crumb-lvl">(Level - {{usrDtls['level_acs']}})</span>
                </div>
            </div>
        </div>

        <!-- All other clients: unchanged -->
        <div class="flex flex-1 justify-between" *ngIf="!isRmcHdr">
            <div class="flex-container justify-center gap-2 w-full">
                <div *ngIf="usrDtls['clnt_id'] == 1000053">
                    <img src="/assets/images/ramanaidu.png"
                        style="margin: 5px; width: 65px; border-radius: 50%; box-shadow: 2px 2px 8px #44556673;">
                </div>
                <div class="client-name">
                    {{clntTntDtls[0].clnt_nm}}
                    <div *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">
                        <div style="    margin-top: -16px;"> <span *ngIf="usrDtls.ste_nm"
                                class="hyrch-lvl-css">{{usrDtls.ste_nm}} </span>
                            <span *ngIf="usrDtls.dstrt_nm" class="hyrch-lvl-css"> - {{usrDtls.dstrt_nm}} </span>
                            <span *ngIf="usrDtls.ulb" class="hyrch-lvl-css"> - {{usrDtls.ulb}} </span>
                            <span *ngIf="usrDtls.mndl_nm" class="hyrch-lvl-css"> - {{usrDtls.mndl_nm}}</span>
                            <span *ngIf="usrDtls.gp_nm" class="hyrch-lvl-css"> - GP : {{usrDtls.gp_nm}} </span>
                            <span *ngIf="usrDtls.svm_nm" class="hyrch-lvl-css"> - SVM : {{usrDtls.svm_nm}} </span>
                            <span *ngIf="usrDtls.hbtn_nm" class="hyrch-lvl-css"> - Village : {{usrDtls.hbtn_nm}} </span>
                            <span *ngIf="usrDtls.hyrchy_hndlr_tx && usrDtls.clnt_id != 1000053" class="hyrch-css">
                                (level- {{usrDtls.level_acs}})</span>

                        </div>
                    </div>
                </div>
                <div class="flex" *ngFor="let h of img_data;">
                    <div *ngIf="h.hd_lgo_url_tx" class="flex lg:h-16 lg:w-16 md:h-16 md:w-16 sm:h-14 sm:w-14 mble_dvse-h-14 mble_dvse-w-14 
                        flex-0 items-center justify-center overflow-hidden rounded-full mt-1">
                        <img class="h-full w-full object-cover" [src]="h.hd_lgo_url_tx">
                    </div>
                    <div class="px-2 py-2">
                        <div class="truncate font-bold leading-1 mble_dsply_none"> {{h.hd_prmry_nm}}</div>
                        <div class="text-secondary text-sm truncate leading-1 mble_dsply_none">{{h.hd_scndry_nm}}</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- <div class="flex-1"></div> -->

        <!-- Components -->
        <div class="flex items-center pl-2 space-x-1 sm:space-x-2" [class.rmc-hdr-right]="isRmcHdr">

            <!-- <div class="flex-container">

                <div class="client-name">
                     {{clntTntDtls[0].clnt_nm}}
                </div>

                <div
                    class="flex lg:h-12 lg:w-12 md:h-12 md:w-12 sm:h-10 sm:w-10 mble_dvse-h-10 mble_dvse-w-10  flex-0 items-center justify-center overflow-hidden rounded-full mt-1">
                    <img alt="Contact avatar" class="h-full w-full object-cover" src="/assets/images/logo/apcmsir.png">

                </div>
                <div class="px-2 py-2">
                    <div class="truncate font-bold leading-1 mble_dsply_none"> Sri.Nara Chandrababu Naidu </div>
                    <div class="text-secondary text-sm truncate leading-1 mble_dsply_none"> Hon'ble Chief Minister of
                        Andhra Pradesh </div>
                </div>
            </div> -->

            <!-- <div class="flex">
                <div
                    class="flex lg:h-12 lg:w-12 md:h-12 md:w-12 sm:h-10 sm:w-10 mble_dvse-h-10 mble_dvse-w-10 flex-0 items-center justify-center overflow-hidden rounded-full mt-1">
                    <img alt="Contact avatar" class="h-full w-full object-cover"
                        src="/assets/images/logo/narayanasir_apmaud.png">
                </div>
                <div class="px-2 py-2">
                    <div class="truncate font-bold leading-1 mble_dsply_none"> Sri.Pongure Narayana </div>
                    <div class="text-secondary text-sm truncate leading-1 mble_dsply_none"> Hon'ble Minister of MA & UD
                    </div>
                </div>
            </div> -->
            <!-- <languages></languages> -->
            <!-- Client 8: notifications bell (existing notifications panel) -->
            <notifications *ngIf="isRmcHdr" class="rmc-hdr-btn"></notifications>
            <!-- Client 8: sidebar/dashboard theme colours (sun "Appearance" button) -->
            <wms-theme-picker *ngIf="usrDtls && usrDtls['clnt_id'] == 8" icon="light_mode"
                [class.rmc-hdr-btn]="isRmcHdr"></wms-theme-picker>
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            <!-- <search [appearance]="'bar'"></search> -->
            <!-- <shortcuts></shortcuts> 77
            <qrscan ></qrscan>
            <notifications></notifications> -->
            <user [class.rmc-hdr-btn]="isRmcHdr" [class.rmc-hdr-user]="isRmcHdr"></user>
            <mat-icon (click)="open()" matTooltip="HELP" class="clickable-icon"
                *ngIf="usrDtls && usrDtls.rle_nm !=  'BCCFC Benificary '">{{ isRmcHdr ? 'help_outline' : 'info' }}</mat-icon>
        </div>
    </div>
    <!-- Horizontal navigation -->
    <fuse-horizontal-navigation class="dark bg-gray-900 print:hidden" [appearance]="navigationAppearance"
        [mode]="isScreenSmall ? 'over' : 'top'" mode="top" [name]="'mainNavigation'"
        [navigation]="navigation.horizontal" *ngIf="usrDtls && usrDtls.rle_nm ==  'BCCFC Benificary '"
        style="background: #fff !important;">

        <ng-container>
            <div style="
    font-size: 18px;
    margin: auto;
    padding: 0px 20px;
    line-height: 55px;
    font-weight: 700;">Beneficiary Loan Dashboard</div>
            <div class="flex items-center justify-center h-16" *ngIf="clntTntDtls && clntTntDtls.length"
                style="background   : #fff;    border-right: 2px solid #e7e7e7; margin: 50px;">
                <img style="width: 100%; margin-top: 0px; height: 64px;" [src]="PrfieImage">
                <img style="width:64px;height:64px ; margin: 0px auto;" [src]="PrfieImage1" *ngIf="lgimg">
            </div>
        </ng-container>
    </fuse-horizontal-navigation>
    <!-- Content -->
    <!-- <div class="flex flex-col flex-auto"> -->
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    <!-- <router-outlet *ngIf="true"></router-outlet> -->
    <!-- sunitha -->
    <!-- <div class="relative flex flex-col h-full  " *ngIf="shwsbmnu">

        <mat-drawer-container class="flex-auto h-full">



           
            <mat-drawer class="w-72 dark:bg-gray-900" [mode]="drawerMode" [opened]="drawerOpened" #drawerSubMnu>

               
                <div class="flex flex-col flex-auto w-full fusecls">

                    <div class="mt-10 mb-8 mx-6 text-3xl font-extrabold tracking-tight leading-none">{{title}}</div>
                   
                    <div class="grid grid-cols-12 gap-2" style="    margin-top: 0.45rem !important;">
                        
                        <div class="col-span-12">
                            <mat-form-field class="mb-4 fuse-mat-no-subscript fuse-mat-rounded fuse-mat-dense"
                                [floatLabel]="'always'">
                                <mat-icon matPrefix class="icon-size-5" [svgIcon]="'heroicons_solid:search'"></mat-icon>
                                <input matInput [(ngModel)]="mnunm" [placeholder]="'Search '"
                                    (keyup)='debouncedSearch($event)'>
                                <button mat-icon-button matSuffix (click)="clearFltr()">
                                    <mat-icon [svgIcon]="'heroicons_solid:x-circle'"></mat-icon>
                                </button>
                            </mat-form-field>
                        </div>
                       

                   
                    <fuse-vertical-navigation [navigation]="sbmnuslst" [inner]="true" [mode]="'side'"
                        [name]="'subNavigation'" [mn_type]="'custom_menu'" [opened]="true"></fuse-vertical-navigation>
                </div>

            </mat-drawer>

           
            <mat-drawer-content class="flex flex-col overflow-hidden">

              
                <div>
                    <div class="relative flex flex-0 ">

                        <div class="flex flex-wrap w-full mx-auto d-hrd">
                            <div class="flex flex-wrap w-full  mx-auto p-2">

                                <div class=" top-card w-full">
                                    <div class="grid grid-cols-12">
                                        <div class="col-span-1" (click)="clsefrm()">
                                            <button mat-icon-button (click)="drawerSubMnu.toggle()">
                                                <mat-icon [svgIcon]="'heroicons_outline:menu'"
                                                    class="cls-icn-clr"></mat-icon>
                                            </button>
                                        </div>
                                        <div class="col-span-11">
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>

                </div>
                <div class="relative flex flex-col w-full h-full" fuseScrollReset>
                    <router-outlet *ngIf="true"></router-outlet>
                </div>

            </mat-drawer-content>

        </mat-drawer-container>

    </div> -->
    <div class="relative flex flex-col h-full  " fuseScrollReset>
        <router-outlet *ngIf="true"></router-outlet>

    </div>
    <!-- sunitha -->
    <!-- </div> -->

    <!-- Footer -->
    <div
        class="relative flex flex-0 items-center justify-start w-full h-8 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary" style="font-size: 12px;">
            <span> {{fter_tx ? fter_tx: 'Dreamstep Software Innovations Pvt. Ltd...'}}</span>
            &copy; {{currentYear}}</span>
    </div>

</div>


<mat-sidenav-container class="cstmIndxalgn" *ngIf="visible">
    <mat-sidenav class="w-screen min-w-screen sm:w-60 sm:min-w-2/3 cstmIndxalgn" [opened]="visible" mode="over"
        position="end" (closedStart)="closeSideBar()">
        <div class="flex flex-row items-center px-6 h-15 min-h-15 text-white common-bg justify-between bg-clr">
            <div class="ml-3 text-2xl font-semibold tracking-tight">
                {{sidebarHeadings}}
            </div>
            <div>
                <button mat-icon-button (click)="closeSideBar()" class="text-white">
                    <mat-icon class="text-white">close</mat-icon>
                </button>
            </div>
        </div>
        <div style="padding: 10px;" *ngIf="content">
            <div style="padding: 20px; text-align: justify;">
                <div class="sctin">
                    <div class="ribbon lgnd">Content</div>
                    <div [innerHTML]="content"></div>
                </div>

                <div class="sctin">
                    <div class="ribbon lgnd">Related documents and images</div>
                    <div class="flex flex-wrap gap-8 my-2" *ngIf="pageDtls?.length">
                        <div class="flex flex-row items-center border border-gray-300 rounded-md p-1 gap-3"
                            *ngFor="let data of pageDtls">
                            <div class="w-16 h-16"
                                *ngIf="data.upld_dcmnt_url_tx.includes('.jpeg') || data.upld_dcmnt_url_tx.includes('.jpg') || data.upld_dcmnt_url_tx.includes('.png')">
                                <img [src]="getFullImageUrl(data.upld_dcmnt_url_tx)" alt="No image Found"
                                    class="object-cover w-full h-full rounded-md"
                                    (click)="openDialog(data.upld_dcmnt_url_tx)" style="cursor: pointer;margin-top:1px">
                                <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                    <div class="truncate" [matTooltip]="data.dcmnt_nm" matTooltipPosition="right"
                                        matTooltipClass="custom-tooltip" style="padding-top: 10px;">{{data.dcmnt_nm}}
                                    </div>
                                </div>
                            </div>
                            <div class="w-16 h-16" *ngIf="data.upld_dcmnt_url_tx.includes('.pdf')">
                                <img src="assets/images/support/pdf.png" alt="No image Found"
                                    class="object-cover w-full h-full rounded-md" style="margin-top:1px"
                                    (click)="openDialog(data.upld_dcmnt_url_tx)">
                                <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                    <div class="truncate" [matTooltip]="data.dcmnt_nm" matTooltipPosition="right"
                                        matTooltipClass="custom-tooltip" style="padding-top: 10px;">{{data.dcmnt_nm}}
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>


    </mat-sidenav>
</mat-sidenav-container>